module.exports = __webpack_public_path__ + "img/divider-left.946edc65.svg";